import { render } from "./SendRecord.vue?vue&type=template&id=5f6ef01e&scoped=true"
import script from "./SendRecord.vue?vue&type=script&lang=js"
export * from "./SendRecord.vue?vue&type=script&lang=js"

import "./SendRecord.vue?vue&type=style&index=0&id=5f6ef01e&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6ef01e"]])

export default __exports__